import { SpaceActionContribution } from '@/services/space-action-contribution';
import { ApiTransferSpace } from '@/infrastructure/api-functions/api-transfer-space';
import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { TransferSpaceContribution } from './transfer-space-contribution';
import { TransferSpaceOptionServiceImp } from './transfer-space-option-service';
import { TransferSpaceOptionService } from './transfer-space-option-service.interface';
import { TransferSpaceServiceImp } from './transfer-space-service';
import { TransferSpaceService } from './transfer-space-service.interface';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
import { createConfirmShareToPublicService } from './confirm-transfer-to-public-service';
import { ConfirmTransferToPublicService } from './confirm-transfer-to-public-service.interface';
export function transferSpacesModule(bind) {
    bind(CommandContribution).to(TransferSpaceContribution);
    bind(TransferSpaceOptionService).to(TransferSpaceOptionServiceImp);
    bind(TransferSpaceService).to(TransferSpaceServiceImp);
    bind(SpaceActionContribution).to(TransferSpaceContribution);
    bind(ApiTransferSpace).to(SpaceApiServiceImpl);
    bind(ConfirmTransferToPublicService).toDynamicValue(createConfirmShareToPublicService());
}
